import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../helper/validtors-helper';

@Component({
  selector: 'app-input-static-fields',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-static-fields.component.html',
  styleUrl: './input-static-fields.component.scss',
})
export class InputStaticFieldsComponent {
  @Input() formName: string = '';
  @Input() formControlValue: string = '';

  // @Input() formGroup!: FormGroup;

  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() isRequired: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() code: string = '';
  @Input() htmlCode: string = '';
  @Input() type: string = '';
  @Input() maxlength: string | number = '';
  @Input() errorMessages: { [key: string]: string } = {};
  showPassword: boolean = false;

  ngOnInit(): void {
    this.addValidators();
  }

  private addValidators(): void {
    const control = this.formGroup?.get(this.formControlValue);

    if (control) {
      const validators = [];

      // Add required validator if applicable
      if (this.isRequired) {
        validators.push(Validators.required);
      }

      // Add whitespace validator
      validators.push(noWhitespaceValidator);

      // Keep existing validators (if any)
      // addValidators preserves existing validators instead of replacing them
      if (typeof (control as any).addValidators === 'function') {
        (control as any).addValidators(validators);
      } else {
        // Fallback: get existing validator and combine (best-effort)
        const existing = control.validator;
        if (existing) {
          control.setValidators([existing, ...validators]);
        } else {
          control.setValidators(validators);
        }
      }
      control.updateValueAndValidity();
    }
  }

  hasError(): boolean {
    const control = this.formGroup?.get(this.formControlValue);
    return !!(control && control.invalid && control.touched);
  }

  getErrorMessage(): string {
    const control = this.formGroup?.get(this.formControlValue);
    if (control?.errors) {
      // Special handling for password to provide detailed missing-requirements message
      // if (this.formControlValue === 'password') {
      //   const value = control.value || '';
      //   const missing: string[] = [];
      //   if (value.length < 8) missing.push('at least 8 characters');
      //   if (!/[A-Z]/.test(value)) missing.push('one uppercase letter');
      //   if (!/[a-z]/.test(value)) missing.push('one lowercase letter');
      //   if (!/\d/.test(value)) missing.push('one number');
      //   if (!/[@$!%*?&#^()_+\-=[\]{}|\\:;"'<>.,\/`]/.test(value))
      //     missing.push('one special character');
      //   if (value.length > 15) missing.push('no more than 15 characters');

      //   if (missing.length) {
      //     return (
      //       'Password must include ' +
      //       missing.join(', ').replace(/, ([^,]*)$/, ' and $1') +
      //       '.'
      //     );
      //   }
      // }

      const errorKey = Object.keys(control.errors)[0];
      return this.errorMessages[errorKey] || 'Invalid field';
    }
    return '';
  }
  isValid(): boolean {
    const control = this.formGroup.get(this.formControlValue);
    return control
      ? control.valid && (control.dirty || control.touched)
      : false;
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
